import React from 'react';
import PropTypes from 'prop-types';

const DIRECTION_VERTICAL = 'vertical';
const DIRECTION_HORIZONTAL = 'horizontal';
const GUIDE_STROKE_WIDTH = 3;

function DropGuide({ offsetX, offsetY, length, direction }) {
  const width = direction === DIRECTION_VERTICAL ? GUIDE_STROKE_WIDTH : length;
  const height = direction === DIRECTION_VERTICAL ? length : GUIDE_STROKE_WIDTH;

  return (
    <div
      className="ws-drop-guide"
      style={{
        transform: `translate(${offsetX}px, ${offsetY}px)`,
        height,
        width,
      }}
    />
  );
}

DropGuide.propTypes = {
  offsetX: PropTypes.number.isRequired,
  offsetY: PropTypes.number.isRequired,
  length: PropTypes.number.isRequired,
  direction: PropTypes.oneOf([DIRECTION_VERTICAL, DIRECTION_HORIZONTAL]).isRequired,
};

export default DropGuide;
